import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import BasePaginationSearchRequest from '../../../RunPay/Admin/IServices/Models/Common/BasePaginationSearchRequest';
import GetContractShopsRequest from '../../../RunPay/Admin/IServices/Models/UserMobile/GetContractShopsRequest';
import WsResponseModel from '../../../SchemaBuilderServer/Models/WsResponseModel';
import PaginationResponse from '../../../Common/ResponseModels/PaginationResponse';
import ContractItemResponse from '../../../RunPay/Admin/IServices/Models/UserMobile/ContractItemResponse';
import ShopItemResponse from '../../../RunPay/Admin/IServices/Models/UserMobile/ShopItemResponse';
import ContractShortItemResponse from '../../../RunPay/Admin/IServices/Models/UserMobile/ContractShortItemResponse';

export default class ContractService {
	webApiService: WebApiService;
	GetPaginatedContractsListEvent = new Events<WsResponseModel<PaginationResponse<ContractItemResponse>>>();
	GetPaginatedShopsListEvent = new Events<WsResponseModel<PaginationResponse<ShopItemResponse>>>();
	GetSingleContractEvent = new Events<WsResponseModel<ContractShortItemResponse>>();
	ApproveContractEvent = new Events<WsResponseModel<Boolean>>();
	RemoveShopEvent = new Events<WsResponseModel<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('ContractService', 'GetPaginatedContractsList', (res: WsResponseModel<PaginationResponse<ContractItemResponse>>) => {
			self.GetPaginatedContractsListEvent.trigger(res);
		});
		webApiService.on('ContractService', 'GetPaginatedShopsList', (res: WsResponseModel<PaginationResponse<ShopItemResponse>>) => {
			self.GetPaginatedShopsListEvent.trigger(res);
		});
		webApiService.on('ContractService', 'GetSingleContract', (res: WsResponseModel<ContractShortItemResponse>) => {
			self.GetSingleContractEvent.trigger(res);
		});
		webApiService.on('ContractService', 'ApproveContract', (res: WsResponseModel<Boolean>) => {
			self.ApproveContractEvent.trigger(res);
		});
		webApiService.on('ContractService', 'RemoveShop', (res: WsResponseModel<Boolean>) => {
			self.RemoveShopEvent.trigger(res);
		});
	}
	GetPaginatedContractsList(request: BasePaginationSearchRequest = null) { 	
        this.webApiService.send('ContractService', 'GetPaginatedContractsList' , request);
    }
	GetPaginatedShopsList(request: GetContractShopsRequest = null) { 	
        this.webApiService.send('ContractService', 'GetPaginatedShopsList' , request);
    }
	GetSingleContract(contractId: number = 0) { 	
        this.webApiService.send('ContractService', 'GetSingleContract' , contractId);
    }
	ApproveContract(contractId: number = 0) { 	
        this.webApiService.send('ContractService', 'ApproveContract' , contractId);
    }
	RemoveShop(shopId: number = 0) { 	
        this.webApiService.send('ContractService', 'RemoveShop' , shopId);
    }
	 // async methods
	async getPaginatedContractsListAsync(request: BasePaginationSearchRequest = null): Promise<PaginationResponse<ContractItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetPaginatedContractsList.bind(this), this.GetPaginatedContractsListEvent)(request);
	}
	async getPaginatedShopsListAsync(request: GetContractShopsRequest = null): Promise<PaginationResponse<ShopItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetPaginatedShopsList.bind(this), this.GetPaginatedShopsListEvent)(request);
	}
	async getSingleContractAsync(contractId: number = 0): Promise<ContractShortItemResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetSingleContract.bind(this), this.GetSingleContractEvent)(contractId);
	}
	async approveContractAsync(contractId: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ApproveContract.bind(this), this.ApproveContractEvent)(contractId);
	}
	async removeShopAsync(shopId: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.RemoveShop.bind(this), this.RemoveShopEvent)(shopId);
	}
}


// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/Services/ContractService.ts